import React, { useRef, useState } from "react";

import { NavMenuRefsProvider } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";
import { ScrollNavMenuContainerClassNames } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock/ScrollNavMenuContainer";
import styles from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock/ScrollNavMenuContainer.module.scss";

import { useCurrentBreakpoint } from "../../utils/hooks";
import { MenuToggle } from "./MenuToggle";

export const ScrollNavMenuContainer = (
    props: React.PropsWithChildren<{
        classNames?: ScrollNavMenuContainerClassNames;
        title: string;
    }>,
) => {
    const viewport = useCurrentBreakpoint();
    const fullBleedRef = useRef<HTMLDivElement | null>(null);
    const navLinksRef = useRef<HTMLUListElement | null>(null);

    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    return (
        <NavMenuRefsProvider value={{ fullBleedRef, navLinksRef }}>
            <div
                ref={fullBleedRef}
                className={props.classNames?.navMenuFullBleed}
            >
                {viewport.belowTablet && (
                    <MenuToggle
                        isOpen={isMenuOpen}
                        onToggle={() => setIsMenuOpen((open) => !open)}
                        title={props.title}
                    />
                )}
                <nav>
                    <ul
                        id="mobile-nav-list"
                        ref={navLinksRef}
                        className={styles.navItemList}
                    >
                        {props.children}
                    </ul>
                </nav>
            </div>
        </NavMenuRefsProvider>
    );
};
